module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-super.e93a6bdf.jpg";